import { useState, useEffect } from 'react';

/**
 * A React hook that returns true if the viewport matches the given mobile media query.
 * @param mediaQuery CSS media query string (default: max-width 768px)
 */
export function useIsMobile(mediaQuery = '(max-width: 768px)'): boolean {
  const getMatch = () =>
    typeof window !== 'undefined'
      ? window.matchMedia(mediaQuery).matches
      : false;

  const [isMobile, setIsMobile] = useState<boolean>(getMatch);

  useEffect(() => {
    const mql = window.matchMedia(mediaQuery);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);

    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
    } else {
      mql.addListener(onChange);
    }

    setIsMobile(mql.matches);

    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener('change', onChange);
      } else {
        mql.removeListener(onChange);
      }
    };
  }, [mediaQuery]);

  return isMobile;
}
